/**
 * Messages browsers give a fetch that never completed — the request was cut
 * off (page backgrounded, navigated away, connection dropped), not answered
 * with an error. Chromium "Failed to fetch", Safari "Load failed", Firefox
 * "NetworkError when attempting to fetch resource.", generic "network error",
 * and React's "Connection closed." when an RSC Flight stream is cut mid-read
 * (LOCARORA-WEB-42).
 */
export const NETWORK_ABORT_MESSAGES: readonly string[] = [
  "Failed to fetch",
  "Load failed",
  "NetworkError when attempting to fetch resource.",
  "network error",
  "Connection closed.",
];

/**
 * True when `error` is a fetch that was cut off rather than a failure of ours.
 *
 * For catch blocks around Server Actions that report to Sentry: the user
 * already sees the retry state, and the abort carries no information we can
 * act on (LOCARORA-WEB-G: getProductReviews on mobile Safari, 404 events).
 */
export function isNetworkAbortError(error: unknown): boolean {
  return error instanceof Error && NETWORK_ABORT_MESSAGES.includes(error.message);
}
